import { render, staticRenderFns } from "./ConfirmDisabledMFA.vue?vue&type=template&id=2af71984"
import script from "./ConfirmDisabledMFA.vue?vue&type=script&lang=js"
export * from "./ConfirmDisabledMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports